import React, { Component } from 'react';

import { FaPlus } from '@react-icons/all-files/fa/FaPlus';
import { FaMinus } from '@react-icons/all-files/fa/FaMinus';

class FAQ extends Component {
  componentDidMount() {
    const accordionHeader = document.querySelectorAll('.accordion-header');
    accordionHeader.forEach((header: any) => {
      header.addEventListener('click', function () {
        const accordionContent =
          header.parentElement.querySelector('.accordion-content');
        let accordionMaxHeight = accordionContent.style.maxHeight;

        if (accordionMaxHeight == '0px' || accordionMaxHeight.length == 0) {
          accordionContent.style.maxHeight = `${
            accordionContent.scrollHeight + 32
          }px`;
          header.querySelector('.faq-plus').classList.add('hidden');
          header.querySelector('.faq-minus').classList.remove('hidden');
          header.parentElement.classList.add('bg-indigo-50');
        } else {
          accordionContent.style.maxHeight = `0px`;
          header.querySelector('.faq-plus').classList.remove('hidden');
          header.querySelector('.faq-minus').classList.add('hidden');
          header.parentElement.classList.remove('bg-indigo-50');
        }
      });
    });
  }

  render() {
    return (
      <section
        id='faq'
        className='flex flex-col items-center justify-center bg-white md:mx-10 md:my-10 md:flex-row md:space-x-10'
      >
        {/* FAQs */}
        <div className='max-w-7xl mx-auto'>
          <div className='bg-white p-10'>
            <h3 className='text-2xl text-center font-medium text-gray-800'>
              Frequently Answered Questions
            </h3>

            <div className='h-1 w-full mx-auto border-b my-5'></div>

            {/* FAQ Row */}
            <div className='max-w-2xl transition hover:bg-indigo-50 mb-2'>
              <div className='flex flex-row justify-center items-center accordion-header cursor-pointer transition space-x-3 px-5 h-16'>
                <h3 className='grow'>
                  What types of templates does CheQRboard have?
                </h3>
                <div className='flex-none'>
                  <div className='flex flex-col justify-center items-center w-10 h-10 border rounded-full bg-[#89f5a0]'>
                    <FaPlus className='faq-plus text-[#1d191f]' />
                    <FaMinus className='faq-minus text-[#1d191f] hidden' />
                  </div>
                </div>
              </div>

              <div className='accordion-content px-5 pt-0 overflow-hidden max-h-0'>
                <p className='leading-2 font-light py-3 text-justify'>
                  We have more than 10 professionally designed templates available for creating and 
                  modifying content. Create a quiz or poll, conversational forms, calendar events, share facts 
                  and multimedia content like photos, audio and videos. Looking for something else? Let us 
                  know and we'll find a way to build it!
                </p>
              </div>
            </div>

            {/* FAQ Row */}
            <div className='max-w-2xl transition hover:bg-indigo-50 mb-2'>
              <div className='flex flex-row justify-center items-center accordion-header cursor-pointer transition px-5 h-16'>
                <h3 className='grow'>
                  What technical requirements do I need to use CheQRboard?
                </h3>
                <div className='flex-none'>
                  <div className='flex flex-col justify-center items-center w-10 h-10 border rounded-full bg-[#89f5a0]'>
                    <FaPlus className='faq-plus text-[#1d191f]' />
                    <FaMinus className='faq-minus text-[#1d191f] hidden' />
                  </div>
                </div>
              </div>

              <div className='accordion-content px-5 pt-0 overflow-hidden max-h-0'>
                <p className='leading-2 font-light py-3 text-justify'>
                  The CheQRboard platform is web-based. Administrators only need web access, and visitors 
                  only need to have cellular data access on their smartphone. Cell service, but not wifi, 
                  is required for visitors to access the content behind QR codes.
                </p>
              </div>
            </div>

            {/* FAQ Row */}
            <div className='max-w-2xl transition hover:bg-indigo-50 mb-2'>
              <div className='flex flex-row justify-center items-center accordion-header cursor-pointer transition px-5 h-16'>
                <h3 className='grow'>
                  When I update content, do I need to create new QR codes?
                </h3>
                <div className='flex-none'>
                  <div className='flex flex-col justify-center items-center w-10 h-10 border rounded-full bg-[#89f5a0]'>
                    <FaPlus className='faq-plus text-[#1d191f]' />
                    <FaMinus className='faq-minus text-[#1d191f] hidden' />
                  </div>
                </div>
              </div>

              <div className='accordion-content px-5 pt-0 overflow-hidden max-h-0'>
                <p className='leading-2 font-light py-3 text-justify'>
                  Actually, that's the beauty of our system. You can modify the content without having to 
                  replace the physical QR code. Alternatively, you can create as many codes as you like.
                </p>
              </div>
            </div>

            {/* FAQ Row */}
            <div className='max-w-2xl transition hover:bg-indigo-50 mb-2'>
              <div className='accordion-header cursor-pointer transition flex space-x-5 px-5 items-center h-16'>
                <h3 className='grow'>Is CheQRboard an app? Do visitors need to download anything?</h3>
                <div className='flex-none'>
                  <div className='flex flex-col justify-center items-center w-10 h-10 border rounded-full bg-[#89f5a0]'>
                    <FaPlus className='faq-plus text-[#1d191f]' />
                    <FaMinus className='faq-minus text-[#1d191f] hidden' />
                  </div>
                </div>
              </div>

              <div className='accordion-content px-5 pt-0 overflow-hidden max-h-0'>
                <p className='leading-2 font-light py-3 text-justify'>
                  Another benefit of our system: no need for visitors to download anything since we're not an app. 
                  Your content is accessed through the QR Code which can be placed anywhere in or out of your venue. 
                </p>
              </div>
            </div>

            {/* FAQ Row */}
            <div className='max-w-2xl transition hover:bg-indigo-50 mb-2'>
              <div className='accordion-header cursor-pointer transition flex space-x-5 px-5 items-center h-16'>
                <h3 className='grow'>Do I need content, marketing, or graphic design expertise?</h3>
                <div className='flex-none'>
                  <div className='flex flex-col justify-center items-center w-10 h-10 border rounded-full bg-[#89f5a0]'>
                    <FaPlus className='faq-plus text-[#1d191f]' />
                    <FaMinus className='faq-minus text-[#1d191f] hidden' />
                  </div>
                </div>
              </div>

              <div className='accordion-content px-5 pt-0 overflow-hidden max-h-0'>
                <p className='leading-2 font-light py-3 text-justify'>
                  Absolutely not. CheQRboard is a user-friendly platform that is easy to navigate. With a brief 
                  training session, your team will quickly become familiar with the site. We're committed to 
                  providing a stunningly simple user-interface, and we're always open to feedback to offer 
                  you the best experience and tools to execute your vision. We also offer content and 
                  gamification strategy with experts on our team.
                </p>
              </div>
            </div>

            {/* FAQ Row */}
            <div className='max-w-2xl transition hover:bg-indigo-50 mb-2'>
              <div className='accordion-header cursor-pointer transition flex space-x-5 px-5 items-center h-16'>
                <h3 className='grow'>Do you collect any visitor information or personal data?</h3>
                <div className='flex-none'>
                  <div className='flex flex-col justify-center items-center w-10 h-10 border rounded-full bg-[#89f5a0]'>
                    <FaPlus className='faq-plus text-[#1d191f]' />
                    <FaMinus className='faq-minus text-[#1d191f] hidden' />
                  </div>
                </div>
              </div>

              <div className='accordion-content px-5 pt-0 overflow-hidden max-h-0'>
                <p className='leading-2 font-light py-3 text-justify'>
                  We do not collect any identifiable information from visitors or users. Our analytics rely on 
                  engagement metrics (scans and clicks). If there is particular information you'd like to 
                  gather about your visitors, you can create content using our templates to ask information 
                  that may be helpful for your strategic planning.
                </p>
              </div>
            </div>

            {/* FAQ Row */}
            <div className='max-w-2xl transition hover:bg-indigo-50 mb-2'>
              <div className='accordion-header cursor-pointer transition flex space-x-5 px-5 items-center h-16'>
                <h3 className='grow'>
                  How long does it take to get started with CheQRboard?
                </h3>
                <div className='flex-none'>
                  <div className='flex flex-col justify-center items-center w-10 h-10 border rounded-full bg-[#89f5a0]'>
                    <FaPlus className='faq-plus text-[#1d191f]' />
                    <FaMinus className='faq-minus text-[#1d191f] hidden' />
                  </div>
                </div>
              </div>

              <div className='accordion-content px-5 pt-0 overflow-hidden max-h-0'>
                <p className='leading-2 font-light py-3 text-justify'>
                  We can get up and running within a week once you're ready to join us. 
                  Contact info@trakid.com or fill out the form above to get started!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default FAQ;
